import React from 'react';
import { Progress, Button, Modal, ModalHeader, ButtonGroup, ButtonDropdown, ModalFooter, ModalBody, Dropdown, DropdownMenu, DropdownToggle, DropdownItem, Form, FormGroup, FormText, Label, Input } from 'reactstrap';
import $ from 'jquery';
import ValidatedTextBox from '../ValidatedTextBox'
import ValidatedDropDown from '../ValidatedDropDown'
import { connect } from 'react-redux'
import Viewer from '../Viewer';
import { CircularProgress } from '@mui/material';

class AddDocumentFormModal extends React.Component {
  constructor(props) {
    super(props);

    this.toggleDocTypeDd = this.toggleDocTypeDd.bind(this);
    this.attemptSave = this.attemptSave.bind(this);
    this.genericOnChange = this.genericOnChange.bind(this);
    this.genericDropDownChange = this.genericDropDownChange.bind(this);
    this.close = this.close.bind(this);

    var controls = [];
    controls.push({ id: "DocumentRef", valid: false });
    controls.push({ id: "DocumentType", valid: false });

    this.state = {
      docTypedropdownOpen: false,
      dropDownValue: "",
      dropDownText: "Document Type",
      dropDownData: {},
      documentTypes: [],
      dropdownOpen: false,
      selectedDocumentType: {},
      standardControls: controls,
      needControls: true,
      allowSave: 'disabled',
      loading: false,
      numPages: 0,
      pageNumber: 1,
      pdfFile: '',
      documentRef: ''
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.fileName !== prevProps.fileName)
      this.getDocumentTypes();

    if (this.props.fileData !== prevProps.fileData)
      this.renderPDF();
  }

  componentDidMount() {
    this.getDocumentTypes();

    if (this.props.fileData && typeof this.props.fileData.name == 'string')
      this.renderPDF();
  }

  renderPDF = () => {
    const reader = new FileReader();
    reader.readAsDataURL(this.props.fileData);
    reader.onload = () => this.setState({ pdfFile: reader.result });
  }

  getDocumentTypes() {
    //load the available document types
    fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentTypes?SystemDefined=false&FilterDocTypes=true&DocumentType=' + this.props.parentType)
      .then(res => res.json())
      .then(result => {
        //loop the returned values and push them to a local state object
        this.setState({ documentTypes: result });
      }) //should return an array of document types
      .catch(error => {
        //need to log the error
        console.error(error);
      });
  }


  toggleDocTypeDd() {
    this.setState(prevState => ({
      docTypedropdownOpen: !prevState.docTypedropdownOpen
    }));
  }

  genericOnChange(valid, e) {
    var found = false;
    for (var i = 0; i < this.state.standardControls.length; i++) {

      if (this.state.standardControls[i].id === e.currentTarget.id) {
        //console.log("Updating " + this.state.standardControls[i].id);
        this.state.standardControls[i].valid = valid
        this.forceUpdate()
      }

      if (!this.state.standardControls[i].valid) {
        //console.log("found invalid");
        found = true;
        break;
      }
    }
    //console.log(this.state.standardControls);

    this.setState({
      lastActiveBox: e.currentTarget.id,
    })

    if (!found)
      this.setState({ allowSave: '' });
    else
      this.setState({ allowSave: 'disabled' });


  }

  genericDropDownChange(e) {
    this.setState({
      dropDownValue: e.currentTarget.id,
      dropDownText: e.currentTarget.textContent,
      documentTypeConfig: this.state.documentTypes[e.currentTarget.id]
    });

    this.setState({ selectedDocumentType: this.state.documentTypes[e.currentTarget.id] });

    //console.log(this.state.standardControls);

    this.state.standardControls[1].valid = true;
    this.forceUpdate();

    var found = false;

    for (var i = 0; i < this.state.standardControls.length; i++) {
      if (!this.state.standardControls[i].valid) {
        //console.log("found invalid");
        found = true;
        break;
      }
    }

    if (!found)
      this.setState({ allowSave: '' });
    else
      this.setState({ allowSave: 'disabled' });

  }

  close() {
    var controls = [];
    controls.push({ id: "DocumentRef", valid: false });
    controls.push({ id: "DocumentType", valid: false });

    this.setState({
      docTypedropdownOpen: false,
      dropDownValue: "",
      dropDownText: "Document Type",
      dropDownData: {},
      documentTypes: [],
      standardControls: controls,
      selectedDocumentType: {},
      needControls: true,
      allowSave: 'disabled'
    });

    this.getDocumentTypes();

    //reset all the values back as the user has cancelled entry
    this.props.toggleAddModal();
  }

  prevPage = () => {
    let number = this.state.pageNumber - 1
    if (number > 0) {
      this.setState({
        pageNumber: number,
        matchedElements: [],
        searchValue: ''
      })
    }
  }

  nextPage = () => {
    let number = this.state.pageNumber + 1
    if (number <= this.state.numPages) {
      this.setState({
        pageNumber: this.state.pageNumber + 1,
        matchedElements: [],
        searchValue: ''
      })
    }
  }

  gotoPage = (page) => {
    this.setState({
      pageNumber: page
    })
  }

  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  handleSelectClick = (e, object) => {
    let selectedDocument = this.state.selectedDocumentType;

    if (this.state.lastActiveBox == "DocumentRef") {
      let str = this.state.documentRef

      str += object.str.trim();

      this.setState({
        documentRef: str
      })
    } else {
      const result = this.state.selectedDocumentType.Fields.find(elem => {
        return elem.Name === this.state.lastActiveBox;
      });

      if (result.Value)
        result.Value += object.str.trim();
      else
        result.Value = object.str.trim();

      this.setState({
        selectedDocumentType: selectedDocument
      })
    }
  }

  handleUnselectClick = (e, i) => {

  }

  numPagesChange = (num) => {
    this.setState({
      numPages: num
    })
  }

  attemptSave() {
    this.setState({
      loading: true
    })

    var found = false;
    for (var i = 0; i < this.state.standardControls.length; i++) {
      if (!this.state.standardControls[i].valid) {
        //console.log("found invalid");
        found = true;
        break;
      }
    }

    if (!found)
      this.setState({ allowSave: 'disabled' }); //OB Bug 10261
    else {
      this.setState({ allowSave: 'disabled' });
      return;
    }

    var id = $("#DocumentType").val();
    var documentRef = $("#DocumentRef").val();

    var documentType = this.state.documentTypes[id].DocumentType;

    var documentData = {};

    if (this.state.documentTypeConfig !== undefined) {
      if (this.state.documentTypeConfig.Fields !== undefined && this.state.documentTypeConfig.Fields.length !== 0) {
        this.state.documentTypeConfig.Fields.forEach(field => {
          if (field.Name) // Bug 13249: Inscribe - Add document modal crashing on blank doctypeconfig field
          {
            if (field.Value)
              documentData[field.Name] = field.Value;
            else
              documentData[field.Name] = $("#" + field.Name).val();
          }
        });
      }
    }

    var metaData =
    {
      CabinetType: "X3",
      CabinetId: 1,
      PortfolioType: "",
      PortfolioId: {},
      DocumentType: documentType,
      DocumentID: documentRef,
      Version: "1",
      DateTimeCreated: Date.now(),
      ImportType: "Manual",
      UserName: this.props.userReducer.user, //todo - this needs to be sorted during security
      Status: "Active",
      Pages: 1,
      Language: "BRI", //todo - this needs to be sorted during security 
      ActionData: {},
      DocumentData: documentData,
      FileId: {},
      AttachmentLocation: this.props.fileName
    };

    var data = new FormData();

    //apend the file and then the meta data as seperate parms
    data.append("document", this.props.fileData);
    data.append("metaData", JSON.stringify(metaData));
    data.append("parentType", this.props.parentType);
    data.append("parentRef", this.props.parentRef);

    fetch(window.location.protocol + '//' + window.location.host + "/api/archive/documents",
      {
        method: "POST",
        body: data
      })
      .then(() => {
        //$("#cancelButton").click();
        this.setState({ allowSave: '' });
        this.props.toggleAddModal();

        //refresh the master grid - BUG 10250
        this.props.refresh();
      })
      .catch((error) => {
        //display an error 
        //TODO: how??
        this.setState({
          allowSave: '',
          loading: false
        });
        this.props.toggleAddModal();
        //console.log(error);
      });
  }

  render() {
    let metaFields = []
    let dropdownitems = []
    let pdfViewer = <div />

    const { locale, localisation } = this.props.userReducer;
    const { pageNumber, numPages, selectedDocumentType } = this.state;

    for (let i = 0; i < numPages; i++)
      dropdownitems.push(<DropdownItem onClick={() => this.gotoPage(i + 1)}>{i + 1}</DropdownItem>)

    if (Object.keys(this.state.selectedDocumentType) != 0) {
      metaFields.push(<header class="s-h2-head"><div class="s-h2-title">{selectedDocumentType.Description[locale]} Properties</div></header>);
      selectedDocumentType.Fields.forEach(field => {
        switch (field.Type) {
          case "String":
            metaFields.push(<ValidatedTextBox isEnabled={true} value={field.Value && field.Value} id={field.Name} labelText={field.Description[locale] + ":"} onChange={this.genericOnChange} mandatory={field.Mandatory} />);
            break;
          default:
            break;
        }
      })
    }
    else
      metaFields.push(<div />);

    // load PDF viewer with display selected objects 
    if (this.state.pdfFile)
      pdfViewer = <Viewer
        header={false}
        fileType="pdf"
        pdfdata={this.state.pdfFile}
        pageNumber={this.state.pageNumber}
        numPages={this.state.numPages}
        numberOfPagesChange={this.numPagesChange}
        displaySelecObjects
        handleSelectClick={this.handleSelectClick}
        handleUnselectClick={this.handleUnselectClick}
        selectedObjects={this.state.pdfSelectedObjects}
        fieldName={this.state.lastActiveBox}
      />

    return <Modal isOpen={this.props.addmodal} toggle={this.props.toggleAddModal} className='modal-dialog'>
      <ModalHeader toggle={this.props.toggleAddModal}>Add New Document</ModalHeader>
      <ModalBody>
        <Form>
          <div className="modal-view">
            <div className="modal-view-input">
              <ValidatedTextBox isEnabled={true} id="DocumentRef" labelText="Document Ref:" onChange={this.genericOnChange} value={this.state.documentRef} mandatory={true} />
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Label for="frmText" className="mr-sm-2">Upload File Name:</Label>
                <FormText id="frmText" color="muted">{this.props.fileName}</FormText>
              </FormGroup>
              <ValidatedDropDown id="DocumentType" labelText="Document Type:" onChange={this.genericDropDownChange} mandatory={true} documentTypes={this.state.documentTypes} />
              <br />
              <div id='metaData'>
                {metaFields}
              </div>
            </div>
            <div className="modal-view-pdf">
              {numPages > 1 ? <ButtonGroup className="modal-pdf-nav">
                <Button className="navbtn s-fonticon-btn" onClick={this.prevPage}></Button>
                <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                  <DropdownToggle className="navbtn" caret>
                    Page {pageNumber} / {numPages}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dropdownitems}
                  </DropdownMenu>
                </ButtonDropdown>
                <Button className="navbtn s-fonticon-btn" onClick={this.nextPage}></Button>
              </ButtonGroup> : <div />}
              <FormGroup>
                {pdfViewer}
              </FormGroup>
            </div>
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          disabled={this.state.allowSave || this.state.loading}
          onClick={this.attemptSave}>
          {this.state.loading ?
            <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
            :
            localisation['save_button'] ? localisation['save_button'].element_lang : ''
          }
        </Button>
        <Button id="cancelButton" color="secondary" onClick={this.close}>Cancel</Button>
      </ModalFooter>
    </Modal>
  }
}

export default connect(state => state)(AddDocumentFormModal); 
